import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SELECTED_ORG_TOKEN } from '../tokens/selected-org.token';
import { switchMap, take, map } from 'rxjs';
import { environment } from '@env/environment';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const isApiRequest =
    req.url.startsWith(environment.apiBaseUrl) ||
    req.url.startsWith(environment.apiAuthUrl) ||
    req.url.startsWith(environment.apiAccountUrl);

  if (!isApiRequest) {
    return next(req);
  }

  const selectedOrg$ = inject(SELECTED_ORG_TOKEN);

  return selectedOrg$.pipe(
    take(1),
    map((selectedOrg) => selectedOrg?.id || null),
    switchMap((tenantId) => {
      const modifiedReq = tenantId
        ? req.clone({ setHeaders: { 'x-tenant-id': tenantId } })
        : req;
      return next(modifiedReq);
    })
  );
};
